import { isEmpty } from "lodash"
import { getJSON } from "../../shared_component/utils/fetch"

const GET_AFFILIATION_SHOPS = "/api/v4/shops/select_shops/"

export function getAffiliationShops(payload) {
  return async function (dispatch, getState) {
    console.log("payload", payload)
    let user = getState().user || {}
    let { authentication_token } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }
      let url = `${GET_AFFILIATION_SHOPS}?`

      if (!isEmpty(payload)) {
        Object.entries(payload).forEach(([key, value]) => {
          if (value) {
            url += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
          }
        })
        // Remove the trailing "&"
        url = url.slice(0, -1)
      }

      const response = await getJSON(url, {}, request.headers)

      if (response.result) {
        return response
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      return response
    }
  }
}
